module.exports = __webpack_public_path__ + "static/media/Certo-Aerospace-Ltd.bcc08952.png";